module.exports = "/images/other-life-event.png?8fb4dbf205143c5f96e28297201b7379";